import { createContext, useContext, useState } from "react";
import { supabase } from "../supabase/client";
import { ColumnSizing } from "@tanstack/react-table";

export const ProcessesContext = createContext();

export const useProcess = () => {
  const context = useContext(ProcessesContext);
  if (!context) {
    throw new Error(
      "useProcess debe estar dentro del proveedor ProcessesContext"
    );
  }
  return context;
};

export const ProcessesContextProvider = ({ children }) => {
  const [processes, setProcesses] = useState([]);
  const [modal, setModal] = useState(false);

  const getModal = () => {
    setModal(false);
  };

  const getProcesses = async () => {
    const { error, data } = await supabase
      .from("process")
      .select(
        `
            *, 
            class_process(name),
            status_process(name),
            demanding:demanding_id (
                name
            ),
            defendant:defendant_id (
                name
            )
        `
      )
      .eq("status", true)
      .order("created_at", { ascending: false });
    if (error) throw error.message;
    setProcesses(data);
  };

  const getClassProcess = async () => {
    const { error, data } = await supabase
      .from("class_process")
      .select()
      .order("id", { ascending: true });
    if (error) throw error.message;
    return data;
  };

  const getTypeAmount = async () => {
    const { error, data } = await supabase
      .from("type_amount")
      .select()
      .order("id", { ascending: true });
    if (error) throw error.message;
    return data;
  };

  const getProcess = async (id) => {
    const { error, data } = await supabase
      .from("process")
      .select()
      .eq("id", id)
      .single();
    if (error) throw error.message;
    return data;
  };

  const createProcess = async (formData) => {
    const { error, data, status, statusText } = await supabase
      .from("process")
      .insert(formData)
      .select();
    if (status !== 201)
      return {
        title: statusText,
        msg: error.message + " Code:[" + error.code + "]",
        icon: "error",
        code: status,
      };
    return {
      title: statusText,
      msg: "Registro creado correctamente",
      icon: "success",
      code: status,
    };
  };

  const updateProcess = async (formData, id) => {
    try {
      const { error, status, statusText } = await supabase
        .from("processes")
        .update(formData)
        .eq("id", id)
        .select();
      if (status !== 200)
        return {
          title: statusText,
          msg: error.message + " Code:[" + error.code + "]",
          icon: "error",
        };
      await getProcesses();
      setModal(true);
      return {
        title: statusText,
        msg: "Registro actualizado correctamente",
        icon: "success",
      };
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <ProcessesContext.Provider
      value={{
        processes,
        modal,
        getProcesses,
        getClassProcess,
        getTypeAmount,
        getProcess,
        createProcess,
        updateProcess,
        getModal,
      }}
    >
      {children}
    </ProcessesContext.Provider>
  );
};
